import Vue from "vue";
import {
    ButtonConfirm,
    ButtonCancel,
    ButtonCheck,
    ButtonExport,
    ButtonViewAll,
    ButtonRetrieval,
    ButtonDiagnose,
    ButtonImport,
    ButtonNew,
    ButtonEdit,
    ButtonDelete,
    ButtonClose,    
    Back,
    ButtonExpand,
    ButtonSwitch,
    AiChatDialog,    
} from "@/components/index";

import { WrapInput, WrapSelect, WrapCarousel } from './components/wrapper/index'
import DeleteWarning from "./components/DeleteWarning/DeleteWarning.vue";
import EChart from './components/EChart/EChart.vue'
import InfoPanel from "./components/panels/InfoPanel.vue";
import LeftRight from "./components/LeftRight/LeftRight.vue";
import HeadBar from "./components/HeadBar.vue";
import MainListFrame from "./components/Frames/MainListFrame.vue";
import ElementTable from "./components/Table/ElementTable.vue";
import SearchBar from "./components/Bar/SearchBar.vue";
import NormalTable from "./components/Table/NormalTable.vue";
import ButtonSearch from "./components/Buttons/ButtonSearch.vue";
import ButtonReset from "./components/Buttons/ButtonReset.vue";
import Panel from "./components/panels/Panel.vue";
import Icon from "./components/Icon.vue";
import BtnPairs from "./components/BtnPairs.vue";
import JJIcons from "./components/Icons/JJIcons.vue"
import SettingTabs from "./components/SettingTabs/SettingTabs.vue";
import SettingTabsChild from "./components/SettingTabs/SettingTabsChild.vue";
import JJTooltip from "./components/JJTooltip/JJTooltip.vue";

Vue.component('jj-tooltip', JJTooltip)
Vue.component('setting-tabs', SettingTabs)
Vue.component('setting-tabs-child', SettingTabsChild)
Vue.component('jj-icons', JJIcons)
Vue.component("ButtonConfirm", ButtonConfirm);
Vue.component("ButtonCancel", ButtonCancel);
Vue.component("ButtonCheck", ButtonCheck);
Vue.component("ButtonExport", ButtonExport);
Vue.component("ButtonViewAll", ButtonViewAll);
Vue.component("ButtonRetrieval", ButtonRetrieval);
Vue.component("ButtonDiagnose", ButtonDiagnose);
Vue.component("ButtonImport", ButtonImport);
Vue.component("ButtonNew", ButtonNew);
Vue.component("ButtonExpand", ButtonExpand);

Vue.component('WrapInput', WrapInput)
Vue.component('WrapSelect', WrapSelect)
Vue.component('WrapCarousel', WrapCarousel)
Vue.component("ButtonEdit", ButtonEdit);
Vue.component("ButtonDelete", ButtonDelete);
Vue.component("ButtonClose", ButtonClose);
Vue.component("ButtonSwitch", ButtonSwitch);
Vue.component("Back", Back);
Vue.component('AiChatDialog', AiChatDialog);
Vue.component("DeleteWarning", DeleteWarning);
Vue.component('EChart', EChart)

Vue.component('InfoPanel', InfoPanel)
Vue.component('LeftRight', LeftRight)
Vue.component('HeadBar', HeadBar)
Vue.component('MainListFrame', MainListFrame)
Vue.component('ElementTable', ElementTable)
Vue.component('SearchBar', SearchBar)
Vue.component('NormalTable', NormalTable)
Vue.component('Panel', Panel)

Vue.component('ButtonSearch', ButtonSearch)
Vue.component('ButtonReset', ButtonReset)

Vue.component('Icon', Icon)
Vue.component('BtnPairs', BtnPairs)

import "./assets/icons/collapse.svg"
import "./assets/icons/expand.svg"
import "./assets/icons/modify-password.svg"
import "./assets/icons/quit.svg"
import "./assets/icons/bind-notify.svg"
import "./assets/icons/account.svg"
import "./assets/icons/mqtt.svg"
